/*
  List of Quick Ship Fabrics.
  This is a temporary solution until we can get
  the quick ship fabrics from the API.
*/
export default [
  171, //Desert Cheetah
  221, //Ocean Velvet
  264, //White Velvet
  341, //Desert Cheetah
  435, //Talc Linen
  557, //Olive Linen
  586, //Desert Cheetah
  672, //Desert Cheetah
  734, //Jade Cherry Blossom
  735, //Mint Cherry Blossom
  742, //Jade Cherry Blossom
  743, //Mint Cherry Blossom
  745, //Jade Cherry Blossom
  746, //Mint Cherry Blossom
  759, //Cornflower Classic Ticking Stripe
  761, //Cornflower Classic Ticking Stripe
  779, //Sand Odalisque
  796, //Sand Odalisque
  801, //Snow Bouclé
  1006, //Jade Cherry Blossom
  1007, //Mint Cherry Blossom
  1017, //Jade Cherry Blossom
  1018, //Mint Cherry Blossom
  1029, //Black Market Stripe
  1054, //Desert Cheetah
  1108, //Mint Cherry Blossom
  1109, //Jade Cherry Blossom
  1118, //Cornflower Classic Ticking Stripe
  1131, //Sand Odalisque
  1196, //Barnegat Plaid
  1201, //Barnegat Plaid
  1225, //Blue Market Stripe
  1226, //Coal Windowpane
  1227, //French Blue Linen
  1250, //Zucchini Luxe Velvet
];
